module.exports = __webpack_public_path__ + "img/staple.76af5570.svg";